<template>
  <div>
    <PageMain
      ref="main"
      :loading="loading"
      :tableData="tableData"
      @reload="reload()"
      @checkbox-change="(e) => $emit('checkbox-change', e)"
    >
      <PageHeader ref="header" slot="header" @query="getData">
        <slot />
      </PageHeader>
      <pagination
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>
  </div>
</template>
<script>
import PageMain from './table.vue'
import PageHeader from './header.vue'
import BaseTable from '@/mixins/base-table'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader },
  props: { custCode: { type: String, default: '' } },
  data() {
    return { usePage: true, loading: false, tableData: [] }
  },
  methods: {
    async getData(form) {
      this.loading = true
      const res = await this.$api
        .masterCustomerBrandOptionsApi({ ...form, custCode: this.custCode })
        .catch(() => null)
      this.loading = false
      this.setData(res)
    },
  },
}
</script>
